import PropTypes from "prop-types";

import ServiceWrapper from "../utils/ServiceWrapper";

/**
 * A collection of static API calls for VOE
 * @name ClientDao
 */
const ClientDao = (props) => {
    const { action } = props;
    const options = {
        headers: {
            Accept: "application/json",
            "Access-Control-Max-Age": null,
            "Content-Type": "application/json"
        }
    };

    switch (action) {
        case "userHeadersRead":
            options.method = "GET";
            options.url =
                window.location.port.toString() === "9000"
                    ? "http://localhost:8080/headers"
                    : `https://${window.location.host}/headers`;
            break;
        default:
            return null;
    }

    return ServiceWrapper.serviceCall({
        options,
        ...props
    });
};

ClientDao.propTypes = {
    action: PropTypes.string.isRequired
};

export default ClientDao;
